import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CubeComponent } from './cube/cube.component';
import { MenuComponent } from './menu/menu.component';
import { CubeContentsComponent } from './cube-contents/cube-contents.component';
import { FooterComponent } from './footer/footer.component';
import { RightMenuComponent } from './right-menu/right-menu.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslationService } from './app.translation-service';
import { DropdownComponent } from './dropdown/dropdown.component';
import { DialogComponent } from './dialog/dialog.component';
import { DialogService } from './app.dialog-service';
import { PopupComponent } from './popup/popup.component';

@NgModule({
	declarations: [
		AppComponent,
		CubeComponent,
		CubeContentsComponent,
		FooterComponent,
		MenuComponent,
		RightMenuComponent,
		DropdownComponent,
		DialogComponent,
		PopupComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule
	],
	providers: [TranslationService, DialogService],
	bootstrap: [AppComponent]
})
export class AppModule { }
